import { render, staticRenderFns } from "./GameSearch.vue?vue&type=template&id=afd436b0&scoped=true"
import script from "./GameSearch.vue?vue&type=script&lang=ts"
export * from "./GameSearch.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameSearch.vue?vue&type=style&index=0&id=afd436b0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "afd436b0",
  "4fea34e5"
  
)

export default component.exports